<div class="wrapper" [ngClass]="{'white': showWhiteDialog}" *ngIf="openDialog">
  <div class="dialog" role="alertdialog" aria-live="assertive" aria-labelledby="dialogTitle" aria-describedby="dialogBody">
    <div class="dialog-title" id="dialogTitle" aria-label="dialog title">{{msg.title}}</div>
    <div class="close-wrapper" (click)="closeDialog(true, $event)" *ngIf="showWhiteDialog">&times;</div>
    <div class="dialog-body" id="dialogBody" [innerHTML]="msg.body"></div>
    <div class="additional-info" *ngIf="showWhiteDialog">{{msg.additionalInfo}}</div>
    <div class="buttons" *ngIf="!showWhiteDialog">
      <button [attr.aria-label]="msg.buttons.ok" class="ok-btn" (click)="closeDialog(true, $event)">{{msg.buttons.ok}}</button>
      <button *ngIf="msg.type === 'prompt'" (click)="closeDialog(false, $event)">{{msg.buttons.cancel}}</button>
    </div>
    <div class="button-wrapper" *ngIf="showWhiteDialog">
      <button aria-label="Take Picture Again" class="take-another-btn" (click)="closeDialog(true, $event)">Take Picture Again</button>
    </div>
  </div>
</div>
